import * as cornerstone from "@cornerstonejs/core";
import $ from "jquery";
import { ViewportType } from "@cornerstonejs/core/enums";
import * as cornerstonetools from "@cornerstonejs/tools";
import {
  getRenderingEngineLocal,
  getToolGroupManager,
  getVOISynchronizer,
  makeBytesAvailableInCache,
} from "./CornerstoneService";
import { getThumbnailViewport } from "./CornerstoneThumbnailService";
import { MouseBindings } from "@cornerstonejs/tools/enums";
import {
  HP_VIEWPORT_ALIGNMENT,
  VIEWPORT_COLUMN,
  VIEWPORT_ROW,
} from "../../../constants/Constants";
import { PASSIVE_TOOLs } from "../../../constants/Constants";
import { utilities } from "@cornerstonejs/tools";
import { getAllThumbnailViewports } from "./CornerstoneThumbnailService";
import { loadAndCacheImage } from "@cornerstonejs/core/loaders/imageLoader";
import { eventTarget } from "@cornerstonejs/core";
import { Enums, annotation } from "@cornerstonejs/tools";
import { _base64ToArrayBuffer } from "../../../service/StudyViewerService";
import {
  getImageSliceDataForVolumeViewport,
} from "@cornerstonejs/core/utilities";
import hardcodedMetaDataProvider from "./MetadataProvider";
import vtkImageData from "@kitware/vtk.js/Common/DataModel/ImageData";
import vtkDataArray from "@kitware/vtk.js/Common/Core/DataArray";
import isRgbaSourceRgbDestJsx from "./isRgbaSourceRgbDest.jsx";
import { MPRViewportsId, getMPRViewportInputs } from "./MPRViewportInput";
import {
  createAndCacheVolume,
  registerVolumeLoader,
} from "@cornerstonejs/core/loaders/volumeLoader";
import { cornerstoneStreamingImageVolumeLoader } from "@cornerstonejs/core";
import { vec3 } from "gl-matrix";
import {
  orientation,
} from "@cornerstonejs/tools/utilities";
import { isMobile } from "react-device-detect";
const cs3DToolsEvents = Enums.Events;

const onRightClick = async (event) => {
  const { element, currentPoints } = event.detail;
  const nearbyToolData = utilities.getAnnotationNearPoint(
    element,
    currentPoints.canvas
  );
  const annotationManager = annotation.state.getAnnotationManager();
  if (nearbyToolData !== null) {
    eventBus.dispatch("contextMenuAdd", {
      show: true,
      mouseEvent: event.detail.event,
      data: nearbyToolData,
      showRemove: true,
    });
  } else {
    eventBus.dispatch("contextMenuAdd", {
      show: true,
      mouseEvent: event.detail.event,
      data: nearbyToolData,
      showRemove: false,
    });
  }
};

const resetContextMenu = (event) => {
  eventBus.dispatch("contextMenuAdd", {
    show: false,
    mouseEvent: null,
    data: null,
    showRemove: false,
  });
};

export const eventBus = {
  on(event, callback) {
    document.addEventListener(event, (e) => callback(e.detail));
  },
  dispatch(event, data) {
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  },
  remove(event, callback) {
    document.removeEventListener(event, callback);
  },
};

const contextMenuHandleClick = (evt) => {
  const mouseUpEvent = evt.detail.event;
  const isRightClick = mouseUpEvent.which === 3;

  const clickMethodHandler = isRightClick ? onRightClick : resetContextMenu;
  clickMethodHandler(evt);
};

function elementEnabledHandler(evt) {
  const { element } = evt.detail;
  element.addEventListener(cs3DToolsEvents.MOUSE_CLICK, contextMenuHandleClick);

  // element.addEventListener(EVENTS.CAMERA_RESET, resetCrosshairs);

  // eventTarget.addEventListener(
  //   Enums.EVENTS.STACK_VIEWPORT_NEW_STACK,
  //   newStackCallback
  // );
}
function elementDisabledHandler(evt) {
  const { element } = evt.detail;
  // element.removeEventListener(
  //   cs3DToolsEvents.MOUSE_CLICK,
  //   contextMenuHandleClick
  // );

  // element.removeEventListener(EVENTS.CAMERA_RESET, resetCrosshairs);

  // // TODO - consider removing the callback when all elements are gone
  // // eventTarget.removeEventListener(
  // //   EVENTS.STACK_VIEWPORT_NEW_STACK,
  // //   newStackCallback
  // // );
}

eventTarget.addEventListener(
  cornerstone.EVENTS.ELEMENT_ENABLED,
  elementEnabledHandler
);

eventTarget.addEventListener(
  cornerstone.EVENTS.ELEMENT_DISABLED,
  elementDisabledHandler
);

const RENDERING_ENGINE_ID = process.env.REACT_APP_RENDERING_ENGINE_ID;

const TOOL_GROUP_ID = process.env.REACT_APP_TOOL_GROUP_ID;
const MPR_TOOL_GROUP_ID = process.env.REACT_APP_MPR_TOOL_GROUP_ID;
const VOI_SYNC_ID = process.env.REACT_APP_VOI_SYNCHRONIZER_ID;

export const getRenderingEngineId = () => {
  return RENDERING_ENGINE_ID;
};

export const renderViewports = async () => {
  const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
  renderingEngine.render();
};

export const getViewportInput = (element, viewportIndex) => {
  return {
    viewportId: "viewport_" + viewportIndex,
    type: ViewportType.STACK,
    element: element,
    defaultOptions: {
      orientation: cornerstone.Enums.OrientationAxis.AXIAL,
      displayArea: {
        storeAsInitialCamera: false,
      },
    },
  };
};

export const activateViewport = async (element, viewportIndex) => {
  //   viewports.forEach((viewport) => {
  const viewportInput = getViewportInput(element, viewportIndex);
  const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
  // console.log("BEFORE ENABLING VIEWPORT")
  renderingEngine.enableElement(viewportInput);
  // addViewportToToolGroup(TOOL_GROUP_ID, viewportInput.viewportId, RENDERING_ENGINE_ID);
  //   });
};

export const resizeViewport = async () => {
  try {
    const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
    renderingEngine.resize(true, true);
  } catch (error) {
    console.log(error);
  }
};

export const rerenderViewport = async () => {
  try {
    const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
    // renderingEngine.resize(true, true);
    renderingEngine.render();
  } catch (error) {
    console.log(error);
  }
};


export const performResize = async () => {
  const isImmediate = false;

    try {
      const beforeResizePositionPresentations = new Map();
      const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
      let viewports = await getAllViewports();
      viewports = viewports.filter(
        (viewport) =>
          viewport.getCurrentImageId() !== undefined &&
          viewport.type !== "orthographic" && !viewport.id.startsWith("thumbnail")
      );
    

      // Store the current position presentations for each viewport.
      viewports.forEach((viewport) => {
        const presentation = _getPositionPresentation(viewport);

        delete presentation.viewReference?.sliceIndex;
        beforeResizePositionPresentations.set(viewport.id, presentation);
      });

      // Resize the rendering engine and render.
      renderingEngine.resize(isImmediate);
      renderingEngine.render();

      // Store the current position presentations for each viewport.
      viewports.forEach((viewport) => {
        const positionPresentation = beforeResizePositionPresentations.get(viewport.id);
        if(positionPresentation){
          _setPositionPresentation(viewport, {
            positionPresentation,
          });
        }
      });
      // Resize and render the rendering engine again.
      //renderingEngine.resize(isImmediate);
      //renderingEngine.render();
    } catch (e) {
      // This can happen if the resize is too close to navigation or shutdown
      console.warn('Caught resize exception', e);
    }
};

const _getPositionPresentation = (viewport) => {
  if (!viewport) {
    return;
  }

  return {
    viewportType: viewport.type,
    viewReference: viewport.getViewReference(),
    viewPresentation: viewport.getViewPresentation({ pan: true, zoom: true }),
    viewportId: viewport.id,
  };
}

const _setPositionPresentation = (viewport, viewportPositionPresentation) => {
  const { positionPresentation } = viewportPositionPresentation;
  const viewRef = positionPresentation?.viewReference;
  if (viewRef) {
    viewport.setViewReference(viewRef);
  }

  const viewPresentation = positionPresentation?.viewPresentation;
  if (viewPresentation) {
    viewport.setViewPresentation(viewPresentation);
  }
}

export const getViewport = async (viewportIndex) => {
  const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
  //renderingEngine.resize(true, true);
  const viewports = renderingEngine.getViewport("viewport_" + viewportIndex);
  return viewports;
};

export const getViewportByIdAndRenderingEngine = (viewportIndex, renderingEngineId) => {
  const renderingEngine = cornerstone.getRenderingEngine(renderingEngineId);
  const viewport = renderingEngine.getViewport(viewportIndex);
  return viewport;
};

export const getViewportByIdAndDefRenderingEngine = (viewportIndex) => {
  const renderingEngine = cornerstone.getRenderingEngine(RENDERING_ENGINE_ID);
  const viewport = renderingEngine.getViewport(viewportIndex);
  return viewport;
};

export const enableViewport = (viewport) => {
  const renderingEngine = cornerstone.getRenderingEngine(RENDERING_ENGINE_ID);
  renderingEngine.enableElement(viewport);
};



export const getAllViewports = async () => {
  const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
  return renderingEngine.getViewports();
};

const createVTKImageData = ({
  origin,
  direction,
  dimensions,
  spacing,
  bitsAllocated,
  numberOfComponents,
  numVoxels,
}) => {
  let pixelArray;
  switch (bitsAllocated) {
    case 8:
      pixelArray = new Uint8Array(numVoxels * numberOfComponents);
      break;
    case 16:
      pixelArray = new Float32Array(numVoxels * numberOfComponents);
      break;
    case 24:
      pixelArray = new Uint8Array(numVoxels * 3 * numberOfComponents);
      break;
    default:
  }
  const scalarArray = vtkDataArray.newInstance({
    name: "Pixels",
    numberOfComponents: numberOfComponents,
    values: pixelArray,
  });
  const imageData = vtkImageData.newInstance();
  imageData.setDimensions(dimensions);
  imageData.setSpacing(spacing);
  imageData.setDirection(direction);
  imageData.setOrigin(origin);
  // const rgb_array = imageData.getPointData().getArray(0);
  // console.log(imageData.getPointData());
  // imageData.getPointData().setScalars(rgb_array);
  imageData.getPointData().setScalars(scalarArray);
  return imageData;
};

const updateVTKImageDataFromCornerstoneImageForHeatmap = (
  image,
  imagePlaneModule,
  vtkImageData
) => {
  let origin = imagePlaneModule.imagePositionPatient;
  if (origin === null) {
    origin = [0, 0, 0];
  }
  vtkImageData.setOrigin(origin);
  const pixelData = image.getPixelData();
  const scalars = vtkImageData.getPointData().getScalars();
  const scalarData = scalars.getData();
  if (image.rgba || isRgbaSourceRgbDestJsx(pixelData, scalarData)) {
    if (!image.rgba) {
      console.warn("rgba not specified but data looks rgba ish", image);
    }
    const numPixels = pixelData.length / 4;
    let rgbIndex = 0;
    let index = 0;
    let max = 0;
    let alphaIndex = 3;
    for (let i = 0; i < numPixels; i++) {
      if (max <= pixelData[alphaIndex]) max = pixelData[alphaIndex];
      alphaIndex += 4;
    }

    for (let i = 0; i < numPixels; i++) {
      // scalarData[index++] = pixelData[rgbIndex] >= 120 && pixelData[rgbIndex] <= 220 ? pixelData[rgbIndex++] * 0.7 : pixelData[rgbIndex] > 220 ? pixelData[rgbIndex++] * 0.8 : pixelData[rgbIndex++] * 0;
      // scalarData[index++] = pixelData[rgbIndex] >= 140 && pixelData[rgbIndex] <= 220 ? pixelData[rgbIndex++] * 0.7 : pixelData[rgbIndex] > 220 ? pixelData[rgbIndex++] * 0.6 : pixelData[rgbIndex++] * 0.2;

      let per = pixelData[rgbIndex + 3] / max;
      // scalarData[index++] = pixelData[rgbIndex++] > 20 ? pixelData[rgbIndex] * per : 0;
      // scalarData[index++] = pixelData[rgbIndex++] > 20 ? pixelData[rgbIndex] * per : 0;
      // scalarData[index++] = pixelData[rgbIndex++] > 20 ? pixelData[rgbIndex] * per : 0;
      scalarData[index++] = pixelData[rgbIndex++] * per;
      scalarData[index++] = pixelData[rgbIndex++] * per;
      scalarData[index++] = pixelData[rgbIndex++] * per;
      // pixelData[rgbIndex] > 250
      // ? pixelData[rgbIndex++] * 0.3
      // : pixelData[rgbIndex++] * 0;
      // // scalarData[index++] = pixelData[rgbIndex++];
      // scalarData[index++] =
      // pixelData[rgbIndex] > 250
      // ? pixelData[rgbIndex++] * 0
      // : pixelData[rgbIndex++] * 0;
      // scalarData[index++] = 0;
      // rgbIndex++;
      rgbIndex++;
      // rgbIndex++;
      // rgbIndex++
    }
  } else {
    scalarData.set(pixelData);
  }
  vtkImageData.modified();
  return vtkImageData;
};

const updateVTKImageDataFromCornerstoneImageForOutline = (
  image,
  imagePlaneModule,
  vtkImageData
) => {
  let origin = imagePlaneModule.imagePositionPatient;
  if (origin === null) {
    origin = [0, 0, 0];
  }
  vtkImageData.setOrigin(origin);
  const pixelData = image.getPixelData();
  const scalars = vtkImageData.getPointData().getScalars();
  const scalarData = scalars.getData();
  if (image.rgba || isRgbaSourceRgbDestJsx(pixelData, scalarData)) {
    if (!image.rgba) {
      console.warn("rgba not specified but data looks rgba ish", image);
    }
    const numPixels = pixelData.length / 4;
    let rgbIndex = 0;
    let index = 0;
    for (let i = 0; i < numPixels; i++) {
      scalarData[index++] = pixelData[rgbIndex++]; //*per;
      scalarData[index++] = pixelData[rgbIndex++]; //*per;
      scalarData[index++] = pixelData[rgbIndex++]; //*per;

      // scalarData[index++] = pixelData[rgbIndex] >= 180 && pixelData[rgbIndex] <= 220 ? pixelData[rgbIndex++] * 0.7 : pixelData[rgbIndex] > 220 ? pixelData[rgbIndex++] * 0.8 : pixelData[rgbIndex++] * 0;
      // scalarData[index++] = 0;
      // scalarData[index++] = 0;
      // scalarData[index++] = pixelData[rgbIndex] >= 120 && pixelData[rgbIndex] <= 220 ? pixelData[rgbIndex++] * 0.7 : pixelData[rgbIndex] > 220 ? pixelData[rgbIndex++] * 0.6 : pixelData[rgbIndex++] * 0.25;
      // scalarData[index++] = pixelData[rgbIndex] > 160 ? pixelData[rgbIndex++] * 0.8: pixelData[rgbIndex++] * 0.25;
      // scalarData[index++] = pixelData[rgbIndex] > 240 ? pixelData[rgbIndex++] * 0.4 : pixelData[rgbIndex++] * 0.2;
      // scalarData[index++] = 0;
      // rgbIndex++;
      rgbIndex++;
      // rgbIndex++;
      // rgbIndex++
    }
  } else {
    scalarData.set(pixelData);
  }
  vtkImageData.modified();
  return vtkImageData;
};

export const loadOutline = async (
  outlineStack,
  buttonClicked,
  activeViewportIndex
) => {
  const activeViewport = await getViewport(activeViewportIndex);
  if (!activeViewport) return;
  

  if (!buttonClicked) {
    // setIsHeatMapEnabled(false);
    activeViewport.removeActors(["outline"]);
    activeViewport.render();
    return;
  }

  if (activeViewport.getActor("outline")) {
    activeViewport.removeActors(["outline"]);
  }

  const loadedImageData = activeViewport.getImageData();
  if(!loadedImageData) return; 

  const imageIds = outlineStack;

  cornerstone.metaData.addProvider(
    (type, imageId) => hardcodedMetaDataProvider(type, imageId, imageIds),
    100
  );

  const image = imageIds[activeViewport.getCurrentImageIdIndex()];
  if (image === null || image === "") return;

  const pngData = await loadAndCacheImage(image);

  const imageData = activeViewport.getImageDataMetadata(pngData);
  const vtkImageData = createVTKImageData({
    origin: imageData.origin,
    direction: imageData.direction,
    dimensions: imageData.dimensions,
    spacing: loadedImageData.spacing,
    bitsAllocated: imageData.bitsAllocated,
    numberOfComponents: imageData.numberOfComponents,
    numVoxels: imageData.numVoxels,
  });

  const updatedvtkImageData = updateVTKImageDataFromCornerstoneImageForHeatmap(
    pngData,
    imageData.imagePlaneModule,
    vtkImageData
  );

  const actor = activeViewport.createActorMapper(updatedvtkImageData);

  actor.getProperty().setOpacity(0.2);
  activeViewport.addActor({ uid: "outline", actor, slabThickness: 1 });
  activeViewport.render();
};

export const loadHeatMap = async (
  heatmapStack,
  buttonClicked,
  activeViewportIndex
) => {
  const activeViewport = await getViewport(activeViewportIndex);
  if (!activeViewport) return;

  if (!buttonClicked) {
    // setIsHeatMapEnabled(false);
    activeViewport.removeActors(["heatmap"]);
    activeViewport.render();
    return;
  }

  if (activeViewport.getActor("heatmap")) {
    activeViewport.removeActors(["heatmap"]);
  }

  const loadedImageData = activeViewport.getImageData();
  if(!loadedImageData) return;
  const imageIds = heatmapStack;

  cornerstone.metaData.addProvider(
    (type, imageId) => hardcodedMetaDataProvider(type, imageId, imageIds),
    100
  );

  const image = imageIds[activeViewport.getCurrentImageIdIndex()];
  if (image === null || image === "") return;

  const pngData = await loadAndCacheImage(image);

  const imageData = activeViewport.getImageDataMetadata(pngData);
  const vtkImageData = createVTKImageData({
    origin: imageData.origin,
    direction: imageData.direction,
    dimensions: imageData.dimensions,
    spacing: loadedImageData.spacing,
    bitsAllocated: imageData.bitsAllocated,
    numberOfComponents: imageData.numberOfComponents,
    numVoxels: imageData.numVoxels,
  });

  const updatedvtkImageData = updateVTKImageDataFromCornerstoneImageForHeatmap(
    pngData,
    imageData.imagePlaneModule,
    vtkImageData
  );

  const actor = activeViewport.createActorMapper(updatedvtkImageData);

  actor.getProperty().setOpacity(0.2);
  activeViewport.addActor({ uid: "heatmap", actor, slabThickness: 1 });
  activeViewport.render();
};

export const loadActiveViewport = async (
  thumbnailIndex,
  activeViewportIndex,
  setScale,
  setInitialVOIRange,
  setInitialVOI,
  isSetLastImage,
  setCurrentImage,
  currentImage,
  loadAIOutlineAndHeatmap,
  imageIndex
) => {
  const thumbnailViewport = await getThumbnailViewport(thumbnailIndex);
  if (!thumbnailViewport) return;
  const activeViewport = await getViewport(activeViewportIndex);

  if (!activeViewport) return;
  activeViewport.removeAllActors();
  cornerstone.metaData.addProvider(
    (type, imageId) =>
      hardcodedMetaDataProvider(type, imageId, thumbnailViewport.imageIds),
    10000
  );
  const imageIndexVal = isSetLastImage ? thumbnailViewport.getImageIds().length -1 : imageIndex && imageIndex > 0 ? imageIndex : 0;
  await activeViewport.setStack(thumbnailViewport.getImageIds(), imageIndexVal);
  const currentImageId = imageIndexVal;
  
  try {
    activeViewport.render();
  } catch (error) {
    console.log(error);
  }
  if(currentImageId == currentImage)
    loadAIOutlineAndHeatmap();
  
  setCurrentImage(currentImageId);
  console.log("================Inside the loadActiveViewport before the setInitialVOI: ",activeViewport);
  console.log("================Inside the loadActiveViewport before the setInitialVOI: ",activeViewport.getProperties().voiRange);
  setInitialVOIRange(activeViewport.getProperties().voiRange);
  if(setInitialVOI)
    setInitialVOI(activeViewport.getProperties().voiRange);
  loadDefaultWindowLevelToolGroup(activeViewport, activeViewportIndex);
  
  const toolGroup = getToolGroupManager(TOOL_GROUP_ID);
  toolGroup.addViewport(activeViewport.id, RENDERING_ENGINE_ID);
  return thumbnailViewport.imageIds.length - 1;
};

export const updateViewport = async (
  viewportIndex,
  imageIndex,
  initialRange
) => {
  const activeViewport = await getViewport(viewportIndex);
  await activeViewport.setImageIdIndex(imageIndex);
  activeViewport.render();

};

export const changeStack = async (
  viewportIndex,
  thumbnailId,
  stack,
  originalStack,
  showOriginal,
  currentImageIndex,
  setLoaderRunning,
  ref
) => {
  // setLoaderRunning(true);
  // ref.current.continuousStart();
  const activeViewport = await getViewport(viewportIndex);
  if (!activeViewport) {
    // ref.current.complete();
    return;
  }
  // console.log(activeViewport);
  currentImageIndex = activeViewport.getCurrentImageIdIndex();
  if (showOriginal) {
    await activeViewport.setStack(originalStack.imageIds, currentImageIndex);
    // console.log(activeViewport)
    activeViewport.render();
    // ref.current.complete();
  } else {
    await activeViewport.setStack(stack.imageIds, currentImageIndex);
    activeViewport.render();
  }
  // ref.current.complete();
};

export const getCurrentImage = async (viewportIndex) => {
  const activeViewport = await getViewport(viewportIndex);
  return activeViewport.getCurrentImageIdIndex();
};

export const loadDefaultWindowLevelToolGroup = (
  activeViewport,
  activeViewportIndex
) => {
  // const toolGroup = getToolGroupManager(
  //   TOOL_GROUP_ID + "_" + activeViewportIndex
  // );
  const toolGroup = getToolGroupManager(TOOL_GROUP_ID);
  // toolGroup.addTool(cornerstonetools.WindowLevelTool.toolName);
  toolGroup.addViewport(activeViewport.id, RENDERING_ENGINE_ID);
  // toolGroup.setToolActive(cornerstonetools.WindowLevelTool.toolName, {
  //   bindings: [
  //     {
  //       mouseButton: MouseBindings.Primary, // Left Click
  //     },
  //   ],
  // });
  // console.log(toolGroup);
};

export const getInitialZoom = async (viewportIndex, setScale, event) => {
  const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
  const activeViewport = renderingEngine.getViewport(
    "viewport_" + viewportIndex
  );

  const imageData = activeViewport.getImageData();

  if (!imageData) return;

  if (event) {
    if (event.detail.camera.scale) {
      setScale(event.detail.camera.scale);
      return;
    }

    const { spacing } = imageData;

    const scale =
      (activeViewport.element.clientHeight * spacing[0] * 0.5) /
      event.detail.camera.parallelScale;

    setScale(scale);
    return;
  }

  if (activeViewport.initialCamera.scale) {
    setScale(activeViewport.initialCamera.scale);
    return;
  }

  const { spacing } = imageData;

  const scale =
    (activeViewport.element.clientHeight * spacing[0] * 0.5) /
    activeViewport.initialCamera.parallelScale;

  setScale(scale);
  return;
};

export const toggleReferenceLines = async (
  isReferenceLineEnabled,
  viewportIndex
) => {
  const activeViewport = await getViewport(viewportIndex);

  if (!activeViewport.getCurrentImageId()) {
    return;
  }
  const toolGroup = getToolGroupManager(TOOL_GROUP_ID);

  if (isReferenceLineEnabled) {
    //toolGroup.setToolDisabled(cornerstonetools.ReferenceLinesTool.toolName);
    try {
      toolGroup.setToolConfiguration(
        cornerstonetools.ReferenceLinesTool.toolName,
        {
          sourceViewportId: activeViewport.id,
        },
        true
      );
    } catch (error) {
      console.log(error);
    }
    toolGroup.setToolEnabled(cornerstonetools.ReferenceLinesTool.toolName);
  } else {
    toolGroup.setToolDisabled(cornerstonetools.ReferenceLinesTool.toolName);
  }

};

export const setToolOnActiveViewport = async (
  viewportIndex,
  toolName,
  previousToolName,
  activeViewportIndex
) => {
  const activeViewport = await getViewport(viewportIndex);

  if (!activeViewport.getCurrentImageId()) {
    return;
  }

  const toolGroup = getToolGroupManager(TOOL_GROUP_ID);
  // toolGroup.addViewport(activeViewport.id, RENDERING_ENGINE_ID);

  if (previousToolName) {
    if (PASSIVE_TOOLs.includes(previousToolName)) {
      toolGroup.setToolPassive(previousToolName);
    } else {
      toolGroup.setToolDisabled(previousToolName);
      if((previousToolName === cornerstonetools.ZoomTool.toolName) 
        || (previousToolName === cornerstonetools.PanTool.toolName)){
          toolGroup.setToolActive(
            cornerstonetools.ZoomTool.toolName,
            {
              bindings: [{
                mouseButton: MouseBindings.Secondary, // Left Click
              }],
            }
          );
          toolGroup.setToolActive(
            cornerstonetools.PanTool.toolName,
            {
              bindings: [{
                mouseButton: MouseBindings.Auxiliary, // Left Click
              }],
            }
          );
        }
       
    }
  }

  // toolGroup.addTool(toolName);
  if (toolName === cornerstonetools.PlanarFreehandROITool.toolName) {
    if (viewportIndex === activeViewportIndex) {
      toolGroup.setToolConfiguration(
        cornerstonetools.PlanarFreehandROITool.toolName,
        {
          calculateStats: true,
        },
        false
      );
    }
  }

  if (toolName === cornerstonetools.ArrowAnnotateTool.toolName) {
    if (viewportIndex === activeViewportIndex) {
      toolGroup.setToolConfiguration(
        cornerstonetools.ArrowAnnotateTool.toolName,
        {
          getTextCallback: (doneChangingTextCallback) =>
            doneChangingTextCallback(prompt("Enter your annotation:")),
          changeTextCallback: (data, eventData, doneChangingTextCallback) =>
            doneChangingTextCallback(prompt("Change your annotation:")),
          arrowFirst: false,
        },
        false
      );
    }
  }

  if (toolName === cornerstonetools.ZoomTool.toolName && isMobile) {
    toolGroup.setToolActive(toolName, {
      bindings: [
        {
          numTouchPoints: 2, // Left Click
        },
      ],
    });
  } else {
    toolGroup.setToolActive(toolName, {
      bindings: [
        {
          mouseButton: MouseBindings.Primary, // Left Click
        },
      ],
    });
  }

  // console.log(toolGroup);
};

export const setInvert = async (viewportIndex) => {
  const activeViewport = await getViewport(viewportIndex);
  activeViewport.setProperties({
    invert: !activeViewport.getProperties().invert,
  });
  activeViewport.render();
};

export const setRotation = async (viewportIndex, rotationVal) => {
  const activeViewport = await getViewport(viewportIndex);
  let { rotation } = activeViewport.getViewPresentation();
  if(rotation === 0 && rotationVal < 0) rotation = 360; 
  activeViewport.setViewPresentation({
    rotation: rotation + rotationVal, 
  });

  activeViewport.render();
};

export const resetRotation = async (viewportIndex) => {
  const activeViewport = await getViewport(viewportIndex);
 
  activeViewport.setViewPresentation({
    rotation: 0, 
  });

  activeViewport.render();
};

export const FlipVertically = async (viewportIndex) => {
  const activeViewport = await getViewport(viewportIndex);
  const { flipVertical } = activeViewport.getCamera();

  activeViewport.setCamera({
    flipVertical: !flipVertical,
  });
  activeViewport.render();
};

export const resetViewPlaneOfCamera = async (viewportIndex) => {
  const activeViewport = await getViewport(viewportIndex);
  console.log("===============inside resetViewPlaneOfCamera");
  activeViewport.setCamera({
    flipHorizontal: false,
    flipVertical: false,
    focalPoint: [0, 0, 0],  
    parallelProjection: true,
    parallelScale: 1, 
    position: [0, 0, -1], 
    rotation: 0,
    viewAngle: 90,
    viewPlaneNormal: [0, 0, -1],
    viewUp: [0, -1, 0],  
  });
  // setTimeout(() => {
    
  //   resetViewport();
  // }, 1000);
  
};

export const resetStackPosition = async (viewportIndex) => {
  const activeViewport = await getViewport(viewportIndex);
    let displayArea = createDisplayArea(1.1, 0.5);
    activeViewport.setOptions({
      displayArea: displayArea.displayArea,
      imageArea:displayArea.displayArea.imageArea,
      imageCanvasPoint:displayArea.displayArea.imageCanvasPoint,
    });

  activeViewport.render();
};

export const setStackPosition = async (viewportIndex, position, rotation, flipHorizontal) => {
  const activeViewport = await getViewport(viewportIndex);
    let displayArea;
    switch (position) {
      case HP_VIEWPORT_ALIGNMENT.LEFT:
        displayArea = createDisplayArea(1.1, [0, 0.5], rotation, flipHorizontal); // Adjusted for left position
        break;
      case HP_VIEWPORT_ALIGNMENT.RIGHT:
        displayArea = createDisplayArea(1, [1, 0.5], rotation, flipHorizontal); // Adjusted for right position
        break;
      case HP_VIEWPORT_ALIGNMENT.CENTER:
      default:
        // displayArea = createDisplayArea(1, [0.5, 0.5], rotation, flipHorizontal); // Centered display
        break;
    }
    if(displayArea){
      activeViewport.setOptions({
        displayArea: displayArea.displayArea,
        imageArea:displayArea.displayArea.imageArea,
        imageCanvasPoint:displayArea.displayArea.imageCanvasPoint,
      });
    }

    activeViewport.render();
};
function createDisplayArea(
  size,
  pointValue,
  rotation = 0,
  flipHorizontal = false
) {
  const canvasValue = pointValue;
  const imagePoint = Array.isArray(pointValue)
    ? pointValue
    : [pointValue, pointValue];
  const canvasPoint = Array.isArray(canvasValue)
    ? canvasValue
    : [canvasValue, canvasValue];
  return {
    rotation,
    flipHorizontal,
    displayArea: {
      imageArea: Array.isArray(size) ? size : [size, size],
      imageCanvasPoint: {
        imagePoint,
        canvasPoint,
      },
    },
  };
}

export const FlipHorizontally = async (viewportIndex) => {
  const activeViewport = await getViewport(viewportIndex);
  const { flipHorizontal } = activeViewport.getCamera();
  
  activeViewport.setCamera({
    flipHorizontal: !flipHorizontal,
  });
  activeViewport.render();
};

export const applyViewportStates = async (viewportIndex, viewportState) => {
  const activeViewport = await getViewport(viewportIndex);
  if(viewportState?.camera)
    activeViewport.setCamera(viewportState?.camera);

  if(viewportState?.properties)
    activeViewport.setProperties(viewportState?.properties);
    

  activeViewport.render();
};

export const reset = async (
  viewportIndex,
  annotationData,
  annotationDataAI,
  addedAnnotation,
  isMPRActive = false ,
   maskImages,
  thumbnailIndex 
) => {
  let allAddedAnnotation = [];
  const annotationManager = annotation.state.getAnnotationManager();
  annotationManager.removeAllAnnotations();
  for (const key in annotationData) {
    for (const key2 in annotationData[key]) {
      annotationData[key][key2].map((item) => {
        if (item !== null || item !== undefined) {
          annotationManager.addAnnotation(item.annotation);
        }
      });
    }
  }
  
  for (const key in annotationDataAI) {
    for (const key2 in annotationDataAI[key]) {
      const exists = addedAnnotation.some(item => item.id == key2);
      if(exists) {
        annotationDataAI[key][key2].map((item) => {
          if (item !== null || item !== undefined) {
            annotationManager.addAnnotation(item.annotation);
          }
        });
      }
    }
  }

  let activeViewport = null;
  if (isMPRActive) {
    activeViewport = await getMPRViewport(viewportIndex);
  } else {
    activeViewport = await getViewport(viewportIndex);
  }

  const maskImageId = `${thumbnailIndex}_${activeViewport?.getCurrentImageIdIndex()}`;
  delete maskImages[maskImageId];
  for (const key in maskImages){
 
      for(const key2 in maskImages[key].maskAnnotationData){

         annotationManager.addAnnotation( maskImages[key].maskAnnotationData[key2]);
      }
    
  }

  activeViewport.resetCamera({
    resetPan: true,
    resetZoom: true,
    resetToCenter: true,
    storeAsInitialCamera: true,
  });
  activeViewport.resetProperties();
  activeViewport.setProperties({
    invert: false,
  });
  activeViewport.render();
};

export const resetViewport = async (viewportIndex) => {
  try {
    const activeViewport = await getViewport(viewportIndex);
    
    if (!activeViewport) {
      throw new Error(`Viewport not found for index: ${viewportIndex}`);
    }

    activeViewport.reset();
    activeViewport.resetCamera();
    activeViewport.render();
    
  } catch (error) {
    console.error(`Error resetting viewport at index ${viewportIndex}:`, error);
  }
};


export const fitToScreen = async (viewportIndex, isMPRActive) => {
  let activeViewport;
  if (isMPRActive) {
    activeViewport = await getMPRViewport(viewportIndex);
  } else {
    activeViewport = await getViewport(viewportIndex);
  }
  activeViewport.resetCamera();
};

export const originalResolution = async (viewportIndex, isMPRActive) => {
  let activeViewport;
  if (isMPRActive) {
    activeViewport = await getMPRViewport(viewportIndex);
  } else {
    activeViewport = await getViewport(viewportIndex);
  }
  activeViewport.resetCamera();
  const camera = activeViewport.getCamera();
  const { focalPoint, position } = camera;
  const imageData = activeViewport.getImageData();
  const { spacing } = imageData;
  const parallelScale = activeViewport.element.clientHeight * spacing[0] * 0.5;
  // console.log(parallelScale);
  activeViewport.setCamera({
    parallelScale,
    focalPoint,
    position,
  });
  
};

export const checkForLateralSeries = async () => {
  const allThumbnailViewports = await getAllThumbnailViewports();

  for (let i = 1; i < allThumbnailViewports.length; i++) {
    const imageId = await loadAndCacheImage(
      allThumbnailViewports[i].imageIds[0]
    );
    const imagePlane = cornerstone.metaData.get(
      "imagePlaneModule",
      imageId.imageId
    );
    if (imagePlane && imagePlane.rowCosines && imagePlane.columnCosines) {
      const row = [
        Math.round(imagePlane.rowCosines[0]),
        Math.round(imagePlane.rowCosines[1]),
        Math.round(imagePlane.rowCosines[2])
      ];
      const column = [
        Math.round(imagePlane.columnCosines[0]),
        Math.round(imagePlane.columnCosines[1]),
        Math.round(imagePlane.columnCosines[2])
      ];
      const normal = [];
      vec3.cross(normal, column, row);

      if (Math.abs(normal[0]) === 1)
        //Sagittal{
        return i;
    }

  }
  return -1;
};

export const showOutlineOnViewport = async (
  viewportIndex,
  thumbnailIndex,
  imageId
) => {
  const viewport = await getViewport(viewportIndex);
  const element = viewport.element;
  const canvas = element.children[0].children[0];
  const ctx = canvas.getContext("2d");
  var img = new Image();
  img.src = imageId;

  ctx.drawImage(img, 0, 0);
  viewport.render();
};

export const loadDownloadImageViewport = async (
  activeViewportIndex,
  viewportIndex
) => {
  const activeViewport = await getViewport(activeViewportIndex);
  if (!activeViewport) return;
  const downloadImageViewport = await getViewport(viewportIndex);
  await downloadImageViewport.setStack(activeViewport.imageIds, 0);
  downloadImageViewport.render();
  return activeViewport.imageIds.length - 1;
};

export const downloadImageFromCanvas = async (
  stackId,
  currentImage,
  viewportIndex,
  filename
) => {
  const activeViewport = await getViewport(viewportIndex);
  const ele = activeViewport.element;
  setTimeout(() => {
    let data = ele
      .querySelector(".viewport-element")
      .querySelector("canvas")
      .toDataURL("image/" + "jpeg", 1);
    const link = document.createElement("a");
    link.href = data;
    if (filename === "") {
      link.setAttribute("download", `${stackId}_${currentImage + 1}.jpeg`);
    } else {
      link.setAttribute("download", `${filename}.jpeg`);
    }
    link.click();
    return;
  }, 1000);
};

export const downloadSeriesFromCanvas = async (
  stackId,
  stack,
  imageCount,
  setLoadingState,
  setScrollCount,
  filename
) => {
  const activeViewport = await getViewport(VIEWPORT_ROW * VIEWPORT_COLUMN + 1);

  if (
    activeViewport.getCurrentImageIdIndex() + 1 ===
    activeViewport.imageIds.length
  ) {
    await downloadImageFromCanvas(
      stackId,
      activeViewport.getCurrentImageIdIndex(),
      VIEWPORT_ROW * VIEWPORT_COLUMN + 1,
      filename
    );
    setLoadingState(false);
    return;
  }

  const ele = activeViewport.element;
  setTimeout(async () => {
    let data = ele
      .querySelector(".viewport-element")
      .querySelector("canvas")
      .toDataURL("image/" + "jpeg", 1);
    const link = document.createElement("a");
    link.href = data;
    if (filename === "") {
      link.setAttribute(
        "download",
        `${stackId}_${activeViewport.getCurrentImageIdIndex() + 1}.jpeg`
      );
    } else {
      link.setAttribute(
        "download",
        `${filename}_${activeViewport.getCurrentImageIdIndex() + 1}.jpeg`
      );
    }
    link.click();
    await activeViewport.setImageIdIndex(
      activeViewport.getCurrentImageIdIndex() + 1
    );
    setScrollCount(activeViewport.getCurrentImageIdIndex());
    downloadSeriesFromCanvas(
      stackId,
      stack,
      imageCount,
      setLoadingState,
      setScrollCount,
      filename
    );
  }, 1000);
};

export const activateMPRViewports = async (
  setMprViewportElements,
  setIsMPRViewportActivated
) => {
  registerVolumeLoader(
    "cornerstoneStreamingImageVolume",
    cornerstoneStreamingImageVolumeLoader
  );
  // console.log("-************ ACTIVATING MPR VIEWPORTS **********");
  const axialElement = $("#viewport_axial").find("#viewportEntry")[0];
  const sagittalElement = $("#viewport_sagittal").find("#viewportEntry")[0];
  const coronalElement = $("#viewport_coronal").find("#viewportEntry")[0];

  const mprViewportInputs = getMPRViewportInputs(
    axialElement,
    sagittalElement,
    coronalElement
  );
  // console.log(mprViewportInputs);
  const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);

  mprViewportInputs.forEach((viewport) => {
    renderingEngine.enableElement(viewport);
    renderingEngine
      .getViewport(viewport.viewportId)
      .element.addEventListener(
        cs3DToolsEvents.MOUSE_CLICK,
        contextMenuHandleClick
      );
  });

  const toolGroup = getToolGroupManager(MPR_TOOL_GROUP_ID);
  for (let i = 0; i < 3; i++) {
    toolGroup.addViewport(MPRViewportsId[i], RENDERING_ENGINE_ID);
  }

  setMprViewportElements({
    axial: renderingEngine.getViewport(MPRViewportsId[0]).element,
    sagittal: renderingEngine.getViewport(MPRViewportsId[1]).element,
    coronal: renderingEngine.getViewport(MPRViewportsId[2]).element,
  });
  setIsMPRViewportActivated(true);
};

export const loadMPR = async (
  viewportIndex,
  viewportType,
  seriesId,
  setMprLoading,
  setMprViewportElements,
  setIsMPRViewportActivated,
  setVolumeId
) => {
  let viewport;
  if (viewportType === "viewport") {
    viewport = await getViewport(viewportIndex);
  } else {
    viewport = await getThumbnailViewport(viewportIndex);
  }

  makeBytesAvailableInCache();
  cornerstone.cache.purgeVolumeCache();

  const volumeId = "cornerstoneStreamingImageVolume: myVolume_" + seriesId;
  setVolumeId(volumeId);
  const imageIds = viewport.imageIds;
  const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
  await activateMPRViewports(setMprViewportElements, setIsMPRViewportActivated);
  
  const volume = await createAndCacheVolume(volumeId, {
    imageIds,
  });
  volume.load();

  for (let i = 0; i < MPRViewportsId.length; i++) {
    const viewport = renderingEngine.getViewport(MPRViewportsId[i]);
    await viewport.setVolumes([{ volumeId }]);
    viewport.render();
  }

  renderMPRViewport();
};

export const renderMPRViewport = async () => {
  const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
  const viewports = renderingEngine.getVolumeViewports();
  viewports.forEach((viewport) => {
    viewport.render();
  });
};

export const getInitialZoomForMPR = async (viewportIndex, setScale, event) => {
  const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
  const activeViewport = renderingEngine.getViewport(
    MPRViewportsId[viewportIndex]
  );
  let imageData;
  try {
    imageData = activeViewport.getImageData();
  } catch (error) {
    console.warn(error);
  }
  if (!imageData) return;

  if (event) {
    if (event.detail.camera.scale) {
      setScale(event.detail.camera.scale);
      return;
    }

    const { spacing } = imageData;

    const scale =
      (activeViewport.element.clientHeight * spacing[0] * 0.5) /
      event.detail.camera.parallelScale;

    setScale(scale);
    return;
  }

  if (activeViewport.initialCamera.scale) {
    setScale(activeViewport.initialCamera.scale);
    return;
  }

  const { spacing } = imageData;

  const scale =
    (activeViewport.element.clientHeight * spacing[0] * 0.5) /
    activeViewport.initialCamera.parallelScale;

  setScale(scale);
  return;
};

export const getSliceData = async (
  viewportIndex,
  setImageCount,
  setCurrentImage
) => {
  const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
  const viewport = renderingEngine.getViewport(MPRViewportsId[viewportIndex]);
  // console.log(viewport.getBlendModes())
  const sliceData = getImageSliceDataForVolumeViewport(viewport);
  // console.log(" -------- IN getsliceData() --------------- ");
  // console.log(sliceData);
  setImageCount(sliceData.numberOfSlices);
  setCurrentImage(sliceData.imageIndex);
};

export const setVOILUTRangeForMPR = async (range, convoluteFlag) => {
  const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
  const allViewports = renderingEngine.getVolumeViewports();
  allViewports.map((viewport) => {
    viewport.setVOI(range);
    // if (convoluteFlag) {
    //   convolute(viewport);
    // }
    viewport.render();
  });
};

export const enableVOISync = async () => {
  const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
  const allViewports = renderingEngine.getVolumeViewports();

  const synchronizer = getVOISynchronizer(VOI_SYNC_ID);

  allViewports.map((viewport) => {
    if (viewport) {
      synchronizer.addSource({
        renderingEngineId: RENDERING_ENGINE_ID,
        viewportId: viewport.id,
      });
      synchronizer.addTarget({
        renderingEngineId: RENDERING_ENGINE_ID,
        viewportId: viewport.id,
      });
    }
  });
};

export const getMPRViewport = async (mprViewportIndex) => {
  const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
  const viewport = renderingEngine.getViewport(
    MPRViewportsId[mprViewportIndex]
  );
  return viewport;
};

export const setToolOnActiveMPRViewport = async (
  viewportIndex,
  toolName,
  oldToolName,
  activeViewportIndex
) => {
  const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
  const activeViewport = renderingEngine.getViewport(
    MPRViewportsId[viewportIndex]
  );

  // if (!activeViewport.getCurrentImageId()) {
  //   return;
  // }

  // const toolGroup = getToolGroupManager(TOOL_GROUP_ID + "_" + viewportIndex);
  const toolGroup = getToolGroupManager(MPR_TOOL_GROUP_ID);

  if (PASSIVE_TOOLs.includes(oldToolName)) {
    toolGroup.setToolPassive(oldToolName);
  } else {
    toolGroup.setToolDisabled(oldToolName);
    toolGroup.setToolDisabled(oldToolName);
      if((oldToolName === cornerstonetools.ZoomTool.toolName) 
        || (oldToolName === cornerstonetools.PanTool.toolName)){
          toolGroup.setToolActive(
            cornerstonetools.ZoomTool.toolName,
            {
              bindings: [{
                mouseButton: MouseBindings.Secondary, // Left Click
              }],
            }
          );
          toolGroup.setToolActive(
            cornerstonetools.PanTool.toolName,
            {
              bindings: [{
                mouseButton: MouseBindings.Auxiliary, // Left Click
              }],
            }
          );
      }
  }
 
  toolGroup.addTool(toolName);
  toolGroup.setToolActive(toolName);
  if (toolName === cornerstonetools.ReferenceLinesTool.toolName) {
    if (viewportIndex === activeViewportIndex) {
      toolGroup.setToolConfiguration(
        cornerstonetools.ReferenceLinesTool.toolName,
        {
          sourceViewportId: activeViewport.id,
        },
        true
      );
      toolGroup.setToolEnabled(cornerstonetools.ReferenceLinesTool.toolName);
    }
    // console.log(toolGroup.getToolInstance());
    return;
  }

  toolGroup.setToolActive(toolName, {
    bindings: [
      {
        mouseButton: MouseBindings.Primary, // Left Click
      },
    ],
  });
  console.log(toolGroup);
};

export const updateOrientationMarkers = async (event, viewportId) => {
  const renderingEngine = await getRenderingEngineLocal(RENDERING_ENGINE_ID);
  const viewport = renderingEngine.getViewport(viewportId);
  const { rotation, previousCamera, camera } = event.detail;
  let flipHorizontal = false;
  let flipVertical = false;
  if (
    camera &&
    camera.flipHorizontal !== undefined &&
    previousCamera.flipHorizontal !== camera.flipHorizontal
  ) {
    flipHorizontal = camera.flipHorizontal;
  }

  if (
    camera &&
    camera.flipVertical !== undefined &&
    previousCamera.flipVertical !== camera.flipVertical
  ) {
    flipVertical = camera.flipVertical;
  }

  let rowCosines, columnCosines;

  if (viewport.type === ViewportType.STACK) {
    if (viewport.getCurrentImageId()) {
      const image = await loadAndCacheImage(viewport.getCurrentImageId());
      const camera2 = viewport.getCamera();
      const imageId = viewport.getCurrentImageId(); 
      const imagePlaneMetadta = cornerstone.metaData.get('imagePlaneModule', imageId);
      // console.log(imagePlaneModule);
      ({ rowCosines, columnCosines } = imagePlaneMetadta);
    } else {
      return "";
    }
  } else {
    const { viewUp, viewPlaneNormal } = viewport.getCamera();
    const viewRight = vec3.create();
    vec3.cross(viewRight, viewUp, viewPlaneNormal);

    columnCosines = [-viewUp[0], -viewUp[1], -viewUp[2]];
    rowCosines = viewRight;
  }

  if (!rowCosines || !columnCosines) {
    return "";
  }

  const rowString = orientation.getOrientationStringLPS(rowCosines);
  const columnString = orientation.getOrientationStringLPS(columnCosines);
  const oppositeRowString = orientation.invertOrientationStringLPS(rowString);
  const oppositeColumnString = orientation.invertOrientationStringLPS(columnString);

  let markers = {
    top: oppositeColumnString,
    left: oppositeRowString,
    right: rowString,
    bottom: columnString,
  };

  if (flipVertical) {
    markers.top = orientation.invertOrientationStringLPS(markers.top);
    markers.bottom = orientation.invertOrientationStringLPS(markers.bottom);
  }

  if (flipHorizontal) {
    markers.left = orientation.invertOrientationStringLPS(markers.left);
    markers.right = orientation.invertOrientationStringLPS(markers.right);
  }

  if (rotation === 90 || rotation === -270) {
    return {
      top: markers.left,
      left: orientation.invertOrientationStringLPS(markers.top),
      right: orientation.invertOrientationStringLPS(markers.bottom),
      bottom: markers.right, // left
    };
  } else if (rotation === -90 || rotation === 270) {
    return {
      top: orientation.invertOrientationStringLPS(markers.left),
      left: markers.top,
      bottom: markers.left,
      right: markers.bottom,
    };
  } else if (rotation === 180 || rotation === -180) {
    return {
      top: orientation.invertOrientationStringLPS(markers.top),
      left: orientation.invertOrientationStringLPS(markers.left),
      bottom: orientation.invertOrientationStringLPS(markers.bottom),
      right: orientation.invertOrientationStringLPS(markers.right),
    };
  }

  return markers;
};

export const loadAIImages = async (stack) => {
  stack.forEach(async (image, index) => {
    if (image !== "" && image !== null) await loadAndCacheImage(image);
  });
};
